import { render, staticRenderFns } from "./CusSelectDialog.vue?vue&type=template&id=45dcdff0&scoped=true&"
import script from "./CusSelectDialog.vue?vue&type=script&lang=js&"
export * from "./CusSelectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_b0bc45a465820d8b7f28c12ef4ef53a5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dcdff0",
  null
  
)

export default component.exports